import { Notice } from "@/data/common/notice";
import { UpdateNoticePayload } from "@/data/payload/notice/update-notice-payload";
import { NoticeRepository } from "@/domain/repository/notice-repository";
import { NoticeType } from "@/utils/enum/notice-type-enum";
import { SATError, SATResult } from "@sadtx/sat-error";

export class UpdateNoticeByUuidUsecase {
  constructor(private readonly noticeRepository: NoticeRepository) {}

  async execute(noticeUuid: string, notice: Notice): Promise<SATResult<void, SATError>> {
    const payload: UpdateNoticePayload = {
      notice: {
        boardTitle: notice.boardTitle,
        title: notice.title,
        body: notice.body,
        type: notice.type,
        startViewDate: notice.startViewDate,
        endViewDate: notice.endViewDate,
        appVersion: notice.appVersion,
        isPriority: notice.isPriority,
        priorityNumber: notice.priorityNumber,
      },
    };

    const result = await this.noticeRepository.updateNoticeByUuid(noticeUuid, payload);

    if (result.isSuccess) {
      console.log("[UpdateNoticeByUuidUsecase] :: execute :: 공지사항 수정 성공");
      return SATResult.success(undefined);
    }

    console.log("[UpdateNoticeByUuidUsecase] :: execute :: 공지사항 수정 실패", result.error);
    return SATResult.failure(result.error);
  }
}
